<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (custom)="onCustom($event)" (detail)="onDetail($event)" [columns]="columns" [dataProviderParams]="params" [icon]="'receipt'"
              [dataProvider]="importService" [title]="'Failed imports'" noDataMessage="Hooray no imports failing"></data-table>
</page-content>
